<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <v-card class="pa-6" style="border-radius: 12px;">
      <v-card-title class="font-weight-bold pa-0 mb-4" style="font-size: 20px; color: #333; display: flex; justify-content: space-between; align-items: center;">
        Crear cuenta para operar dentro de la web
        <v-btn icon small @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <!-- Error message inside the dialog (Req 7.6) -->
        <v-alert v-if="errorMsg" type="error" dense dismissible class="mb-3" @input="errorMsg = ''">
          {{ errorMsg }}
        </v-alert>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="usuario.name"
            label="Nombre de usuario"
            :rules="textRules"
            required
            outlined
          ></v-text-field>

          <v-text-field
            v-model="usuario.identificador"
            label="Identificador para su página"
            :rules="textRules"
            required
            outlined
          ></v-text-field>

          <v-text-field
            v-model="usuario.email"
            label="Correo electrónico"
            :rules="emailRules"
            required
            outlined
          ></v-text-field>

          <!-- Chips de sugerencia de dominio -->
          <div class="mb-3" style="display: flex; flex-wrap: wrap; gap: 6px;">
            <v-chip
              v-for="dom in dominios"
              :key="dom"
              small
              outlined
              color="blue darken-1"
              style="cursor: pointer;"
              @click="completarDominio(dom)"
            >
              {{ dom }}
            </v-chip>
          </div>

          <v-text-field
            v-model="usuario.password"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="showPass ? 'text' : 'password'"
            label="Contraseña"
            hint="Mínimo 5 caracteres"
            counter
            outlined
            @click:append="showPass = !showPass"
          ></v-text-field>

          <v-text-field
            v-model="confirmPassword"
            :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min, confirmRule]"
            :type="showConfirm ? 'text' : 'password'"
            label="Confirmar contraseña"
            counter
            outlined
            @click:append="showConfirm = !showConfirm"
          ></v-text-field>
        </v-form>

        <v-btn
          block
          depressed
          color="#43A047"
          class="white--text mt-2"
          style="text-transform: none; border-radius: 8px;"
          @click="registrar"
        >
          <v-icon left small>mdi-account-plus</v-icon>
          Crear cuenta
        </v-btn>

        <v-btn
          block
          outlined
          class="mt-2"
          style="text-transform: none; border-radius: 8px; border-color: #ccc;"
          @click="loginWithGoogle"
        >
          <img src="@/assets/img/svg/google-icon.svg" alt="Google" width="18" height="18" class="mr-2">
          Registrarse con Google
        </v-btn>

        <div class="text-center mt-3" style="font-size: 13px;">
          <span style="color: #666;">¿Ya tenés cuenta?</span>
          <a href="#" class="font-weight-bold" style="color: #1a73e8; text-decoration: none;" @click.prevent="$emit('cambiar-a-login')">
            Iniciar sesión
          </a>
        </div>

        <v-btn
          block
          outlined
          class="mt-4"
          color="red"
          style="text-transform: none; border-radius: 8px;"
          @click="dialog = false"
        >
          <v-icon left small>mdi-close</v-icon>
          Cerrar Ventana
        </v-btn>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
import usuarioService from "@/services/usuarioService.js";

export default {
  name: 'RegisterCarrito',
  props: {
    value: Boolean
  },
  data: () => ({
    valid: true,
    showPass: false,
    showConfirm: false,
    confirmPassword: '',
    errorMsg: '',
    dominios: ['@gmail.com', '@hotmail.com', '@outlook.com', '@yahoo.com', '@live.com', '@icloud.com'],
    usuario: {
      id: "",
      name: "",
      email: "",
      identificador: "",
      password: ""
    },
    rules: {
      required: (value) => !!value || "Campo Requerido",
      min: (v) => v.length >= 5 || "Mínimo 5 caracteres"
    },
    textRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres"
    ],
    emailRules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+\..+/.test(v) || "Correo debe ser válido"
    ]
  }),
  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
    confirmRule() {
      return () => this.confirmPassword === this.usuario.password || 'Las contraseñas no coinciden';
    }
  },
  methods: {
    async recaptcha() {
      try {
        await this.$recaptchaLoaded();
        return await this.$recaptcha('login');
      } catch (error) {
        console.error('Error en reCAPTCHA:', error);
        throw error;
      }
    },
    loginWithGoogle() {
      localStorage.setItem('redirectAfterLogin', this.$route.path);
      const url = this.$router.resolve({ path: '/api/login/google' }).href;
      window.location.href = url;
    },
    async registrar() {
      if (!this.$refs.form.validate()) return;

      this.errorMsg = '';

      try {
        const token = await this.recaptcha();
        this.usuario.recaptcha = token;
      } catch (error) {
        return;
      }

      usuarioService.save(this.usuario).then((response) => {
        const data = response.data.data;
        localStorage.setItem("token", data.token);
        localStorage.setItem("expiresAt", data.expires_at || '');
        this.$store.commit('setIdentificador', data.identificador);
        this.$store.commit('setLinkPhoto', data.linkPhoto || '');
        this.$store.commit('setRoles', data.roles || []);
        this.$store.commit('setLogueado', true);
        this.dialog = false;
        this.limpiar();
        this.$emit('registro-exitoso');
        // No redirige — se queda en el carrito
      }).catch((e) => {
        const msg = e.response?.data?.message || "Error al registrar";
        this.errorMsg = msg;
      });
    },
    limpiar() {
      this.usuario = { id: "", name: "", email: "", identificador: "", password: "" };
      this.confirmPassword = '';
      this.errorMsg = '';
      this.$refs.form?.resetValidation();
    },
    completarDominio(dominio) {
      const actual = this.usuario.email || '';
      const sinDominio = actual.split('@')[0];
      this.usuario.email = sinDominio + dominio;
    }
  }
};
</script>
